import React, { useState, useEffect } from 'react'
import {
  Button,
  Header,
  Icon,
  Modal,
  Segment,
  Message,
  List,
  Dropdown,
  FormField,
  Form,
} from 'semantic-ui-react'
import PropTypes from 'prop-types'
// import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

import contains from 'validator/es/lib/contains'
import roomXlsx from '../../dummies/room.xlsm'
import indoorXlsx from '../../dummies/indoor.xlsm'
import outdoorXlsx from '../../dummies/outdoor.xlsm'
import fullFledgeXlsx from '../../dummies/Full-fledg.xlsm'
import vehicleXlsx from '../../dummies/vehicle-withMacro.xlsm'
import vehicleFridgeXlsx from '../../dummies/vehicle-FRidge-withMacro.xlsm'
// import { CreateDeviceCreateTemplateXlsx } from '../../services/device'
import { UploadCreationFile } from '../../services/configuration-template'
import { CreateXlsx } from '../../services/xlsx'
import { primaryColor } from '../../constants'
import IntelMsg from '../ItelMsg/index'
import { RefreshCustomerAssetList } from '../../redux/actions/asset'
import { GetPaginationFacilityList } from '../../services/facility/index'
import {
  GetUserCustomers,
  GetCustomerAssetTypes,
} from '../../services/asset/index'
import { setCustomerData } from '../../redux/actions/deviceData'

const AssetBulkUpload = ({ showAssetBulk, setAssetBulkShow }) => {
  const [message, setMessage] = useState()
  const products = JSON.parse(localStorage.getItem('products'))
  const product = localStorage.getItem('product')
  const tenantId = products.filter((p) => p.productName === product)[0]
  console.log('tenantId', tenantId)
  const [code, setCode] = useState('spectro-cold-room')
  // const { t } = useTranslation()
  const dispatch = useDispatch()
  const { userEmail, deviceType } = useSelector((store) => ({
    userEmail: store.auth.userEmail,
    productName: store.product.productName,
    deviceType: store.product.deviceType,
    customer: store.asset.customer,
  }))
  const [assetTypes, setAssetTypes] = useState([])
  const [customerId, setCustomerId] = useState()
  const [disAble, setDisAble] = useState(true)
  const [Xlsx, setXlsx] = useState()
  const [facilityList, setFacilityList] = useState([])
  const [customerList, setCustomersList] = useState()
  const [selectedAsset, setSelectedAsset] = useState()
  const [selectedFacility, setSelectedFacility] = useState()
  const productName = localStorage.getItem('product')
  console.log(
    'email,productName,deviceType',
    userEmail,
    productName,
    deviceType,
  )
  const formValidator = {
    assetType: yup.string().required('You must select Type'),
    facility: yup.string().required('Select Facility'),
  }
  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(yup.object().shape(formValidator)),
  })
  const types = []
  const customerData = []
  useEffect(() => {
    GetUserCustomers(userEmail, productName).then((customers) => {
      customers.forEach((element) => {
        customerData.push({
          text: element.title,
          value: element.tbCustomerId,
        })
      })
      setCustomersList(customerData)
    })
    GetCustomerAssetTypes(userEmail, productName).then((data) => {
      setTimeout(() => {
        data.forEach((asset) => {
          console.log('asset', asset)

          types.push(asset)
        })
        setAssetTypes(types)
      }, 5000)
    })
  }, [])
  useEffect(() => {
    if (customerId) {
      GetPaginationFacilityList(userEmail, productName, customerId, 0, 30).then(
        (data) => {
          console.log('facility', data.data)
          setFacilityList(data.data)
        },
      )
    }
  }, [customerId])
  useEffect(() => {
    if (selectedAsset) {
      if (selectedAsset === 'Room') {
        setXlsx(roomXlsx)
        setCode('spectro-cold-room')
      }
      if (selectedAsset === 'Indoor Fridge') {
        setXlsx(indoorXlsx)
        setCode('spectro-cold-indoor')
      }
      if (selectedAsset === 'Outdoor Fridge') {
        setXlsx(outdoorXlsx)
        setCode('spectro-cold-outdoor')
      }
      if (selectedAsset === 'Full-Fledge Fridge') {
        setXlsx(fullFledgeXlsx)
        setCode('spectro-cold-full-fledge')
      }
      if (selectedAsset === 'Trackable Vehicle') {
        setXlsx(vehicleXlsx)
        setSelectedAsset('Vehicle')
        setCode('spectro-cold-vehicle')
      }
      if (selectedAsset === 'Non-Trackable Vehicle') {
        setXlsx(vehicleFridgeXlsx)
        setSelectedAsset('Vehicle Fridge')
        setCode('spectro-cold-vehicle-fridge')
      }
    }
  }, [selectedAsset])
  const createReport = (data) => {
    const FilesIssuesHeaders = ['Row Number', 'Asset Issue']
    const FileIssuesRaw = data['File errors']
    const FileIssuesIssues = []

    // eslint-disable-next-line no-restricted-syntax,guard-for-in
    for (const [key, value] of Object.entries(FileIssuesRaw)) {
      let rowIssues = value.reduce(
        (string, rowIssue) => `${rowIssue}, ${string}`,
        '',
      )
      rowIssues = rowIssues.slice(0, -1)
      const issue = {
        'Row Number': key,
        'Asset Issue': rowIssues.slice(0, -1),
      }
      FileIssuesIssues.push(issue)
    }
    CreateXlsx('Assets Issues', FilesIssuesHeaders, FileIssuesIssues)
  }

  const createMessageContent = (data) => {
    const totalUploadedDevices = (
      <List.Item>
        <IntelMsg id="totalAssets" />
        &nbsp;
        {data['Total no. of failure'] + data['Total no. of success']}
      </List.Item>
    )

    const totalSucessDevices = (
      <List.Item>
        <IntelMsg id="successAssets" />
        &nbsp;{data['Total no. of success']}
      </List.Item>
    )
    const faluireDecvices = (
      <List.Item>Failed Assets:&nbsp;{data['Total no. of failure']} </List.Item>
    )
    return (
      <List bulleted>
        {totalUploadedDevices}
        {totalSucessDevices}
        {faluireDecvices}
      </List>
    )
  }

  const createErrorMessage = (header, content) => {
    const errorMessage = (
      <Message negative>
        <Message.Header>{header}</Message.Header>
        {content}
      </Message>
    )
    setMessage(errorMessage)
  }
  const addBulk = () => {
    if (selectedAsset && selectedFacility) {
      setDisAble(false)
    }
  }
  const handleUpload = (event) => {
    console.log('file', event.target.files[0])
    const file = event.target.files[0]
    if (file && contains(file.name, '.xlsm')) {
      localStorage.setItem('customer', customerId)
      UploadCreationFile(
        productName,
        selectedAsset,
        selectedFacility,
        file,
        customerId,
        tenantId.tenantId,
        code,
      ).then((res) => {
        if (res.success) {
          dispatch(RefreshCustomerAssetList(true))

          setMessage('')
          setMessage(
            <Message positive>
              <Message.Header> Result</Message.Header>
              {createMessageContent(res.data)}
              <p>
                Issues report &nbsp;
                <Button size="tiny" onClick={() => createReport(res.data)}>
                  <Icon name="download"></Icon>Export
                </Button>
              </p>
            </Message>,
          )
        } else {
          createErrorMessage('Error !', res.msg)
        }
      })
      // readFile(file)
      //   .then((readedData) => {
      //     setInitialData(readedData)
      //
      //     console.log('success', readedData)
      //   })
      //   .catch((error) => console.error(error))
    } else {
      createErrorMessage(
        'Invalid File Type',
        "File extension should be 'xlsx or xlsm' ",
      )
    }
  }

  const handleClose = () => {
    setDisAble(true)
    setMessage(null)
    setCustomerId()
    localStorage.setItem('customer', customerId)
    setAssetBulkShow(false)
  }

  // function createXlsxFile() {
  //   CreateDeviceCreateTemplateXlsx(productName, deviceType, t)
  // }

  return (
    <>
      {customerId ? (
        <Modal
          closeIcon
          open={showAssetBulk}
          centered
          style={{ position: 'relative', height: 'auto' }}
          onClose={() => handleClose()}
          onOpen={() => setAssetBulkShow(true)}
        >
          <Header
            icon="archive"
            content=" Asset Bulk Creation "
            style={{ backgroundColor: '#1678c2', color: 'white' }}
          />
          <Modal.Content scrolling>
            <Form
              style={{
                padding: 10,
                borderRadius: 9,
              }}
              onSubmit={handleSubmit(addBulk)}
              id="bulk"
            >
              <FormField>
                <span>* Asset Type:</span>
                <select
                  name="assetType"
                  ref={register}
                  onChange={(e) => {
                    setSelectedAsset(e.target.value)
                    if (selectedAsset === 'Room') {
                      setXlsx(roomXlsx)
                    }
                    if (selectedAsset === 'Indoor Fridge') {
                      setXlsx(indoorXlsx)
                    }
                    if (selectedAsset === 'Outdoor Fridge') {
                      setXlsx(outdoorXlsx)
                    }
                    if (selectedAsset === 'Full-Fledge Fridge') {
                      setXlsx(fullFledgeXlsx)
                    }
                    if (selectedAsset === 'Trackable Vehicle') {
                      setXlsx(vehicleXlsx)
                    }
                    if (selectedAsset === 'Non-Trackable Vehicle') {
                      setXlsx(vehicleFridgeXlsx)
                    }
                  }}
                >
                  <option disabled selected>
                    {' '}
                  </option>
                  {assetTypes.map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
                {errors.assetType && (
                  <p style={{ color: 'red' }}>{errors.assetType.message}</p>
                )}
              </FormField>
              <FormField>
                <span>* Facility:</span>
                <select
                  name="facility"
                  ref={register}
                  onChange={(e) => setSelectedFacility(e.target.value)}
                >
                  <option disabled selected>
                    {' '}
                  </option>
                  {facilityList.map((facility) => (
                    <option
                      key={facility['asset id']}
                      value={facility['asset id']}
                    >
                      {facility['asset label'] || facility['asset name']}
                    </option>
                  ))}
                </select>
                {errors.facility && (
                  <p style={{ color: 'red' }}>{errors.facility.message}</p>
                )}
              </FormField>
              <Button animated="vertical" from="bulk" type="submit">
                <Button.Content visible>Next</Button.Content>
                <Button.Content hidden>
                  <Icon name="hand point down" />
                </Button.Content>
              </Button>
            </Form>
            <Segment placeholder>
              <Header icon>
                <Icon name="cog" />
                Upload Configurations file
              </Header>
              <Segment.Inline>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '29rem',
                    justifyContent: 'space-between',
                  }}
                >
                  <input
                    disabled={disAble}
                    type="file"
                    accept=".xlsm"
                    onClick={(event) => {
                      /* eslint-disable-next-line no-param-reassign */
                      event.target.value = null
                    }}
                    onChange={(event) => handleUpload(event)}
                    id="upload"
                    style={{ display: 'none' }}
                  />

                  <label htmlFor="upload">
                    <Button
                      disabled={disAble}
                      style={{ backgroundColor: primaryColor, color: 'white' }}
                      onClick={() => document.getElementById('upload').click()}
                    >
                      <Icon name="upload" />
                      Upload Excel File
                    </Button>
                  </label>

                  <a
                    href={Xlsx}
                    download={`${selectedAsset}.xlsm`}
                    disabled={disAble}
                  >
                    <Button primary type="button" disabled={disAble}>
                      <Icon name="download" />
                      Download Template
                    </Button>
                  </a>
                  {/* <ExcelFile initialData={initialData} element={}> */}
                  {/*  <ExcelSheet data={dataSet1} name="Employees"> */}
                  {/*    <ExcelColumn label="Name" value="name" /> */}
                  {/*    <ExcelColumn label="Wallet Money" value="amount" /> */}
                  {/*    <ExcelColumn label="Gender" value="sex" /> */}
                  {/*    <ExcelColumn */}
                  {/*      label="Marital Status" */}
                  {/*      value={(col) => (col.is_married ? 'Married' : 'Single')} */}
                  {/*    /> */}
                  {/*  </ExcelSheet> */}
                  {/* </ExcelFile> */}
                </div>
              </Segment.Inline>
            </Segment>

            {message}
          </Modal.Content>
          <Modal.Actions>
            <Button
              color="#303d54"
              style={{ backgroundColor: primaryColor, color: 'white' }}
              onClick={() => {
                handleClose()
              }}
            >
              Close
            </Button>
          </Modal.Actions>
        </Modal>
      ) : (
        <Modal
          closeIcon
          open={showAssetBulk}
          centered
          style={{ position: 'relative', height: 'auto' }}
          onClose={() => handleClose()}
          onOpen={() => setAssetBulkShow(true)}
        >
          <Header
            icon="archive"
            content=" Asset Bulk Creation "
            style={{ backgroundColor: '#1678c2', color: 'white' }}
          />
          <Modal.Content scrolling>
            <Segment placeholder content>
              <Header icon>
                <Icon name="address card" />
                Select Customer
              </Header>

              <Dropdown
                placeholder="You have to select Customer"
                fluid
                search
                selection
                options={customerList}
                onChange={(e, data) => {
                  setCustomerId(data.value)
                  dispatch(setCustomerData(data.value))
                  localStorage.setItem('customer', data.value)
                }}
              />
            </Segment>

            {message}
          </Modal.Content>
          <Modal.Actions>
            <Button
              color="#303d54"
              style={{ backgroundColor: primaryColor, color: 'white' }}
              onClick={() => {
                handleClose()
              }}
            >
              Close
            </Button>
          </Modal.Actions>
        </Modal>
      )}
    </>
  )
}
AssetBulkUpload.propTypes = {
  setAssetBulkShow: PropTypes.func.isRequired,
  showAssetBulk: PropTypes.bool.isRequired,
}

// const dataSet1 = []

export default AssetBulkUpload
